import React from 'react';

import { Pill } from '@/components/common/Pill';

import { STAGE_CONFIG } from './stage-config';
import type { MiniTortStage } from './types';

interface MiniTortStageBadgeProps {
  stage: MiniTortStage;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const MiniTortStageBadge: React.FC<MiniTortStageBadgeProps> = ({
  stage,
  size = 'md',
  className,
}) => {
  const config = STAGE_CONFIG[stage];
  if (!config) return null;

  return (
    <Pill variant={config.variant} size={size} className={className}>
      {config.label}
    </Pill>
  );
};
